<template>
    <v-row>
        <v-col cols="12">
            <v-text-field outlined v-model="localEmail" hide-details label="Email destinatario" @input="emitter('email_to', localEmail)"
                required></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-text-field outlined v-model="localSubject" hide-details label="Asunto" @input="emitter('subject', localSubject)"></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-textarea outlined v-model="localBody" hide-details label="Mensaje" rows="5" @input="emitter('body', localBody)"></v-textarea>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'SendByEmailForm',
    props: {
        email_to: String,
        subject: String,
        body: String,
    },
    data() {
        return {
            localEmail: this.email_to,
            localSubject: this.subject,
            localBody: this.body
        }
    },
    methods: {
        emitter(field, value) {
            this.$emit('update:'+field, value);
        },
    }
}
</script>